import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component, useEffect, useState }  from 'react';
import {Tab, Row, Col} from "react-bootstrap";
import { Spinner } from 'reactstrap';
import moment from 'moment';
import { sleep } from './AddBrandModal';
import { af } from 'date-fns/locale';

function AddAffiliateBoostModal({isOpen, closeModal, user}) {
    const [selectedUser, setSelectedUser] = useState(user && user.user ? user.user : null)
    const [searchedUsers, setSearchededUsers] = useState([])
    const [total, setTotal] = useState(null)
    const [loadingData, setLoadingData] = useState(true)
    const [loadingSubmit, setLoadingSubmit] = useState(false)

    const getAmbassadorApprovedUsers = () => {
        return fetch('https://back-api.therunningcollective.fr/affiliates', {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
        })
        .then(res => res.json())
        .then(data => {
            // Trie par ordre alphabétique du firstName
            return data.sort((a, b) =>
                a.user.firstName.localeCompare(b.user.firstName)
            );
        })
        .catch(err => console.log(err));
    };


    useEffect(() => {
        getAmbassadorApprovedUsers().then(data => {
            setSearchededUsers(data);
        }).catch( err =>
            console.log(err)
        ).finally(() => { setLoadingData(false) });
    }, [])

    const handleClose = (selectedUser) => {
        setLoadingSubmit(true)
        let affiliate = {}
        console.log("selectedUser", selectedUser)
        affiliate.userID = selectedUser.userID
        affiliate.total = parseFloat(total)
        return fetch('https://back-api.therunningcollective.fr/affiliate-boost', {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(affiliate)
        }).then(() => {
            setLoadingSubmit(false);
            window.location.reload();
        })
            .catch( err =>
                setLoadingSubmit(false)
            )
    }

    return(
        <Modal
            show={isOpen}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Ajouter un affilié</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    {
                                        loadingData ?
                                        <Row style={{marginTop: "30px", textAlign:"center"}}>
                                            <Col>
                                                <div style={{textAlign: 'center'}}>
                                                    <Spinner animation="border" role="status">
                                                        <span className="visually-hidden"></span>
                                                    </Spinner>
                                                </div>
                                            </Col>
                                        </Row>
                                        : searchedUsers && searchedUsers.length > 0 ?
                                        <>
                                            <Form.Group >
                                                <Form.Label>Liste des affiliés trouvés : </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    custom
                                                    defaultValue={selectedUser && selectedUser.email ? selectedUser.email : ""}
                                                    onChange={(e) => {
                                                    const email = e.target.value;
                                                    const selected = searchedUsers.find(u => u.user.email === email);
                                                    setSelectedUser(selected || null);
                                                    }}
                                                >
                                                    <option value="">Ajouter...</option>

                                                    {searchedUsers?.map(user => (
                                                    <option key={user.user.email} value={user.user.email}>
                                                        {user.user.firstName} {user.user.name} ({user.user.email})
                                                    </option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group >
                                                <Form.Label>Valeur du boost : (€)</Form.Label>
                                                <Form.Control type="text" onChange={(e) => setTotal(e.target.value)} defaultValue={total} placeholder="100"/>
                                            </Form.Group>
                                        </>
                                        : null
                                    }
                                    
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Modal.Body>
            <Modal.Footer>
                {
                    loadingSubmit ?
                    <Row style={{textAlign:"center"}}>
                        <Col>
                            <div style={{textAlign: 'center'}}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden"></span>
                                </Spinner>
                            </div>
                        </Col>
                    </Row>
                    :
                    <>
                        <Button variant="secondary" type="cancel" onClick={closeModal}>
                            Annuler
                        </Button>
                        {
                            selectedUser ?
                                <Button variant="primary" type="submit" onClick={() => handleClose(selectedUser)}>
                                    Valider
                                </Button>
                                : <Button variant="primary" type="submit" disabled>
                                    Valider
                                </Button>

                        }
                    </>
                
            }
                
            </Modal.Footer>
        </Modal>
    )
}

export default AddAffiliateBoostModal;

export function sliceIntoChunks(arr, chunkSize) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
    }
    return res;
}